export const STICKER_PAGE_SIZE = 20;

export const PACK_STATUS = {
  DRAFT: 'DRAFT',
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  BANNED: 'BANNED',
  PENDING_REVIEW: 'PENDING_REVIEW',
};

export const PACK_STATUS_OPTIONS = [
  { value: '', label: '全部' },
  { value: PACK_STATUS.DRAFT, label: '草稿' },
  { value: PACK_STATUS.ACTIVE, label: '上架' },
  { value: PACK_STATUS.INACTIVE, label: '下架' },
  { value: PACK_STATUS.BANNED, label: '封禁' },
  { value: PACK_STATUS.PENDING_REVIEW, label: '待審' },
];

export const PACK_STATUS_FORM_OPTIONS = PACK_STATUS_OPTIONS.filter((o) => o.value);

export const ACCESS_TYPE_OPTIONS = [
  { value: 'FREE', label: 'FREE' },
  { value: 'VIP_SUBSCRIPTION', label: 'VIP_SUBSCRIPTION' },
  { value: 'CREATOR_SUBSCRIPTION', label: 'CREATOR_SUBSCRIPTION' },
  { value: 'PERMANENT_PURCHASE', label: 'PERMANENT_PURCHASE' },
  { value: 'LIMITED_EVENT', label: 'LIMITED_EVENT' },
  { value: 'CUSTOM', label: 'CUSTOM' },
];

export const VISIBILITY_OPTIONS = [
  { value: 'PUBLIC', label: 'PUBLIC' },
  { value: 'UNLISTED', label: 'UNLISTED' },
  { value: 'PRIVATE', label: 'PRIVATE' },
  { value: 'GROUP_ONLY', label: 'GROUP_ONLY' },
  { value: 'PLATFORM_ONLY', label: 'PLATFORM_ONLY' },
];

export const ANIMATION_TYPE_OPTIONS = [
  { value: 'STATIC', label: 'STATIC' },
  { value: 'ANIMATED_WEBP', label: 'ANIMATED_WEBP' },
  { value: 'APNG', label: 'APNG' },
  { value: 'LOTTIE', label: 'LOTTIE' },
  { value: 'GIF', label: 'GIF' },
  { value: 'THREE_D', label: 'THREE_D' },
];

export function buildStickerPackPageParams(pageNo, filters = {}, pageSize = STICKER_PAGE_SIZE) {
  const params = { pageNo, pageSize };
  if (filters.status) {
    params.status = filters.status;
  }
  if (filters.name?.trim()) {
    params.name = filters.name.trim();
  }
  return params;
}

export function formatPackStatus(status) {
  const found = PACK_STATUS_FORM_OPTIONS.find((o) => o.value === status);
  return found?.label || status || '—';
}

export const EMPTY_PACK_FORM = {
  name: '',
  publisherDisplayName: 'Formosa',
  uploaderType: 'OFFICIAL',
  visibility: 'PUBLIC',
  accessType: 'FREE',
  subscriptionRequirement: '',
  status: PACK_STATUS.ACTIVE,
  coverObjectKey: '',
  description: '',
  category: '',
  language: 'en_US',
  tags: '',
  sort: 0,
  version: 1,
};

export const EMPTY_STICKER_FORM = {
  emoteCode: '',
  name: '',
  description: '',
  objectKey: '',
  mimeType: 'image/png',
  width: 240,
  height: 240,
  animationType: 'STATIC',
  subscriptionTier: '',
  visibility: 'PUBLIC',
  category: '',
  language: 'en_US',
  tags: '',
  status: PACK_STATUS.ACTIVE,
  sort: 0,
};
